module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UA2NEY/tc-custom/9781615953882.jpg?1732132327452",
      "alt": "This image is the cover for the book Bullet Hole, Alan Saxon Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bullet Hole, Alan Saxon Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the world of championship golf, the stakes are high and passions run to match. And never more so than at the British Open Championship, particularly when it is played at Saint Andrews, venerable home of the game.")]), _c('p', [_vm._v("For Alan Saxon, too long ago a champion and once again in top form, this is a crucial tournament, and he must carefully prepare himself. But his ritual is rudely interrupted by the appearance of a young, pretty golf groupie who starts by demanding a lift and ends up naked and dead in his bed.")]), _c('p', [_vm._v("She is not the only casualty, and it fast becomes clear that someone wants Saxon out of the open. As the championship builds to its climax, at last Saxon thinks he knows who the killer is—but then he must decide: which hole is the bullet hole?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Keith Miles\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0